module.exports = __webpack_public_path__ + "static/media/module7.239d636c.png";